import axios from "axios";
import { globalSettingSuccessMsg } from "@/helpers/snackbar/global-setting-success-filter";

const state = {
  globalSettings: [],
  largeGlobalSettings: [],
  navHeaderActive: [],
  navHeaderAvailable: [],
  validationErrors: []
};

const actions = {
  getAllGlobalSettings: ({ commit }) => {
    return axios.get(`/global-settings`)
      .then((resp) => {
        commit("setGlobalSettingsData", resp.data.global_settings);
        commit("setLargeGlobalSettingsData", resp.data.large_global_settings);
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getGlobalSetting: ({ dispatch }, ident) => {
    return axios.get(`/global-settings/${ident}`)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  getNavSetting: ({ commit, dispatch }, ident) => {
    return axios.get(`/global-settings/navigation/${ident}`)
      .then((resp) => {
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  updateGlobalSettings: ({ state, dispatch, commit }) => {
    return axios.patch(`/global-settings`, state)
      .then((resp) => {
        commit("setValidationErrors", []);
        dispatch("snackbar/successMessage", "Your changes have been saved.", { root: true });
        return resp;
      })
      .catch((err) => {
        if (err.response && err.response.status === 422) {
          commit("setValidationErrors", err);
          dispatch("snackbar/errorMessage", "Error: Invalid settings", { root: true });
        } else {
          dispatch("snackbar/errorMessage", err, { root: true });
        }
        return Promise.reject(err);
      });
  },

  updateGlobalSetting: ({ dispatch }, payload) => {
    return axios.patch(`/global-settings/${payload.ident}`, { value: payload.value })
      .then((resp) => {
        dispatch("getGlobalSetting", payload.ident);
        dispatch("snackbar/successMessage", globalSettingSuccessMsg(payload.ident), { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  updateNavSetting: ({ commit, dispatch }, payload) => {
    return axios.patch(`/global-settings/navigation/${payload.ident}`, payload.items)
      .then((resp) => {
        dispatch("snackbar/successMessage", `Successfully updated navigation settings`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },

  uploadGlobalSettingImage: ({ dispatch }, formData) => {
    return axios.post(`/global-settings/images/${formData.get("ident")}`, formData)
      .then((resp) => {
        dispatch("getAllGlobalSettings");
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  uploadGlobalOgImage: ({ dispatch }, formData) => {
    return axios.post(`/global-settings/images/global_og_image`, formData)
      .then((resp) => {
        dispatch("getAllGlobalSettings");
        return resp;
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }
};

const mutations = {
  setGlobalSettingsData: (state, payload) => {
    state.globalSettings = payload;
  },

  setLargeGlobalSettingsData: (state, payload) => {
    state.largeGlobalSettings = payload;
  },

  setValidationErrors: (state, payload) => {
    state.validationErrors = [];
    if (payload &&
        payload.response &&
        payload.response.data &&
        payload.response.data.detail
    ) {
      state.validationErrors = payload.response.data.detail;
    }
  }
};

export default {
  state,
  actions,
  mutations
};
